(function($) {
  var CHAR_MAX = 10;
  var SYMBOL_COST = 2;
  var SYMBOL_TEXT_COST = 2;
  var SIDE_LABELS = ['Vorderseite', 'Rückseite'];
  var sideModes = ['zeichen', 'zeichen'];
  var previewSideCount = 1;
  var physicalSideMap = [0];

  function setPhysicalSideMap(map) {
    physicalSideMap = Array.isArray(map) && map.length ? map.slice() : [0];
  }

  function getPhysicalSideIndex(uiSideIndex) {
    if (physicalSideMap[uiSideIndex] != null) return physicalSideMap[uiSideIndex];
    return uiSideIndex;
  }

  window.lw101SetPhysicalSideMap = setPhysicalSideMap;

  var KE014_FONT = {
    name: 'G02',
    family: 'NirmalaS, sans-serif'
  };

  var KE014_PREVIEW_IMAGES = {
    silver: window.VIV_LW101.bild_lw101_preview_silver_png,
    gold: window.VIV_LW101.bild_lw101_preview_gold_png,
    rosegold: window.VIV_LW101.bild_lw101_preview_rosegold_png,
    silverVorder: window.VIV_LW101.bild_lw101_preview_silver_vorder_png,
    goldVorder: window.VIV_LW101.bild_lw101_preview_gold_vorder_png,
    rosegoldVorder: window.VIV_LW101.bild_lw101_preview_rosegold_vorder_png
  };


  /* ---- Motive: W-Reihe (2026-08-07) --------------------------------------
     Loest die alte C-Reihe ab — Beschluss Yin: eine einzige Icon-Familie im
     ganzen Shop, Referenz ist KE008. Satz = KE008s zehn + Pfote (W31) = elf.

     ★ Der Bestand kommt jetzt aus DIESER Datei. Frueher wurde er aus dem
     Template-Picker (.product_info_image_json, die alten C1–C50) ausgefiltert
     — das Snippet war also davon abhaengig, dass im Template noch der alte
     Picker steckt. Diese Abhaengigkeit ist damit weg.

     ⚠️ Dateinamen sind unregelmaessig: w01–w10 zweistellig, ab W11
     dreistellig (w011, w027, w031 …). Nicht "vereinheitlichen". */
  var KE014_SYMBOL_NAMES = {
    'w01.png': 'Mini Herz',
    'w02.png': 'Herz',
    'w03.png': 'Doppelherz',
    'w05.png': 'Infinity',
    'w06.png': 'Jesusfisch',
    'w07.png': 'Kreuz',
    'w09.png': 'Engel',
    'w027.png': 'Anker',
    'w031.png': 'Pfote',
    'w036.png': 'Fee',
    'w041.png': 'Stern'
  };

  /* Fixed LW042 shop icon assets — template 2026-herz-geburtsstein-lw101 */
  var KE014_SYMBOLS_FIXED = [
    { code: 'W01', text: 'Mini Herz',  image: window.VIV_LW101.bild_w01_png },
    { code: 'W02', text: 'Herz',       image: window.VIV_LW101.bild_w02_png },
    { code: 'W03', text: 'Doppelherz', image: window.VIV_LW101.bild_w03_png },
    { code: 'W05', text: 'Infinity',   image: window.VIV_LW101.bild_w05_png },
    { code: 'W06', text: 'Jesusfisch', image: window.VIV_LW101.bild_w06_png },
    { code: 'W07', text: 'Kreuz',      image: window.VIV_LW101.bild_w07_png },
    { code: 'W09', text: 'Engel',      image: window.VIV_LW101.bild_w09_png },
    { code: 'W27', text: 'Anker',      image: window.VIV_LW101.bild_w027_png },
    { code: 'W31', text: 'Pfote',      image: window.VIV_LW101.bild_w031_png },
    { code: 'W36', text: 'Fee',        image: window.VIV_LW101.bild_w036_png },
    { code: 'W41', text: 'Stern',      image: window.VIV_LW101.bild_w041_png }
  ];

  /* Altwerte: KH1–KH8 aus der ersten Generation, plus die eine echte
     Umbenennung der W-Reihe (Fisch → Jesusfisch). Ohne diesen Alias faende
     getSymbol() ein altes "Fisch" nicht mehr und das Motiv fiele im
     wiederhergestellten Warenkorb stillschweigend weg. */
  var KE014_KH_LEGACY = {
    'KH1': 'Mini Herz',
    'KH2': 'Herz',
    'KH3': 'Doppelherz',
    'KH4': 'Infinity',
    'KH5': 'Jesusfisch',
    'KH6': 'Anker',
    'KH7': 'Engel',
    'KH8': 'Pfote',
    'Fisch': 'Jesusfisch',
    'Christenfisch': 'Jesusfisch'
  };

  var lw040SymbolsCache = null;

  function imageFileFromUrl(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function normalizeLw040SymbolName(text, imageUrl) {
    var file = imageFileFromUrl(imageUrl);
    if (KE014_SYMBOL_NAMES[file]) return KE014_SYMBOL_NAMES[file];
    if (KE014_KH_LEGACY[text]) return KE014_KH_LEGACY[text];
    return text;
  }

  function normalizeLw040StoredSymbol(name) {
    if (!name) return '';
    return KE014_KH_LEGACY[name] || name;
  }

  /* Nur noch die eigene Liste — kein Umweg mehr ueber den Template-Picker.
     Damit ist die Reihenfolge garantiert und ein aufgeraeumtes Template kann
     den Bestand nicht mehr leerlaufen lassen. */
  function loadLw040Symbols() {
    if (lw040SymbolsCache) return lw040SymbolsCache;
    lw040SymbolsCache = KE014_SYMBOLS_FIXED.slice();
    return lw040SymbolsCache;
  }

  /* Bestellwert = "Anzeigename | CODE" (z. B. "Jesusfisch | W06").
     Der Code ist der einzige Weg, wie der Auftrags-Parser das Bild findet. */
  function formatSymbolOrderValue(name) {
    var resolved = normalizeLw040StoredSymbol(name);
    if (!resolved) return '';
    var symbols = loadLw040Symbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved) {
        return symbols[i].code ? (resolved + ' | ' + symbols[i].code) : resolved;
      }
    }
    return resolved;
  }

  /* ★ Feldname ist die Bedingung dafuer, dass der Auftrags-Parser ein Bild
     zeigt: "… Motiv" → Code wird aufgeloest; "… Text + Motiv" → er trennt
     "Text(Motiv)" selbst und loest den Klammerinhalt auf. Ein Motiv unter dem
     Label "Text" bleibt fuer immer bildlos. `withCode` nur fuer die
     Bestellzeile — in der Kundenbestaetigung waere "| W06" nur Rauschen. */
  function symbolOrderRow(title, engraving, withCode) {
    var text = $.trim(engraving.text || '');
    var sym = withCode
      ? formatSymbolOrderValue(engraving.symbol)
      : normalizeLw040StoredSymbol(engraving.symbol);
    if (text && sym) return { name: title + ' Text + Motiv', value: text + '(' + sym + ')' };
    if (sym)         return { name: title + ' Motiv',        value: sym };
    return { name: title + ' Text', value: text };
  }

  /*
   * Preview calibration for lw101-preview-*.png (top = Vorder, bottom = Rück in one image).
   * Back positions mirror front vertically: same left, top = 100 - top.
   */
  function mirrorPreviewPosBelow(pos) {
    return { top: Math.round((100 - pos.top) * 10) / 10, left: pos.left };
  }

  /* ------------------------------------------------------------------
     LW101 Regler (?lw101tuner=1). Alles NEUTRAL — der Einbau veraendert
     kein einziges bestehendes Vorschaubild.

     Aufbau nach docs/TUNER-VOLLAUSBAU.md:
       G3 Block-Position je Seite   text/motiv gemeinsam verschieben
       G4 Block-Groesse             Textgroesse insgesamt
       G1 Gesamt-Position Motive    alle Motive, ohne die Textlage zu aendern
       G2 Gesamt-Groesse Motive     alle Motive
       K1/K2 Kombi getrennt         im Modus "Symbol + Text" Text bzw. Motiv
                                    einzeln — dort sitzen beide in EINER Marke,
                                    und genau da faellt sonst auf, dass man das
                                    eine nicht ohne das andere bewegen kann

     Groessen liegen bei LW101 in CSS-Variablen (clamp), nicht in JS-Zahlen —
     die Regler schreiben deshalb Faktoren auf die Buehne, nicht px.        */
  var LW101_TUNE = {
    front: {
      text: { dx: 0, dy: 0 },
      motiv: { dx: 0, dy: 0 }
    },
    back: {
      text: { dx: 0, dy: 0 },
      motiv: { dx: 0, dy: 0 }
    },
    blockScale: 1,
    motivScale: 1,
    motivPos: { dx: 0, dy: 0 },
    kombiText: { dx: 0, dy: 0.25 },
    kombiMotiv: { dx: 0, dy: 0 },
    kurzDx: 0
  };

  /* D1: [seite][slug] = { dx, dy, scale } — jedes Motiv einzeln in Lage und
     Groesse. Leer = neutral, der Einbau aendert also kein bestehendes Bild.
     Ueberlagerung, kein Rueckfallwert: das Gesamt-Motiv-Paar (G1/G2) wird
     ADDIERT bzw. MULTIPLIZIERT, wirkt also auch nach dem Einzelabgleich noch. */
  var LW101_ICON_ADJ = {
    front: {
      'mini-herz': { dx: 0, dy: -0.08 },
      herz: { dy: -0.1 },
      doppelherz: { scale: 1.05, dx: 0.02, dy: -0.14 },
      infinity: { scale: 1.3, dy: -0.12 },
      jesusfisch: { dy: -0.12, scale: 1.25 },
      kreuz: { dy: -0.12 },
      engel: { dy: -0.12 },
      anker: { dy: -0.1 },
      pfote: { dy: -0.1 },
      fee: { dy: -0.16 },
      stern: { dy: -0.16 }
    },
    back: {}
  };

  function lw101SymbolSlug(name) {
    return String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* Vorder- und Rueckseite haengen zusammen (Yin 2026-08-16): die Anker
     erledigen die LAGE (mirrorPreviewPosBelow: top → 100−top), die Feinwerte
     werden UNVERAENDERT uebernommen.

     ⚠️ Nicht das Vorzeichen von dy drehen. Das war der erste Versuch und er
     war falsch: auf dem Basisfoto stehen zwei IDENTISCHE Kreuze untereinander,
     keines ist gekippt. `100 − top` trifft die richtige Stelle nur deshalb,
     weil die beiden Kreuz-MITTEN symmetrisch zur Mittellinie liegen — daraus
     folgt kein gespiegeltes Objekt. Ein Motiv, das vorne 0,1 em ueber dem
     Querbalken sitzt, muss hinten ebenfalls 0,1 em darueber sitzen.

     Ein ausdruecklich gesetzter Rueckseiten-Wert gewinnt weiterhin — wer eine
     Seite bewusst anders will, kann das, muss es aber sagen. */
  function lw101UebernimmAdj(v) {
    var out = { dx: v.dx || 0, dy: v.dy || 0 };
    if (v.scale != null) out.scale = v.scale;
    return out;
  }

  function lw101IconAdj(physicalSide, symbolName) {
    var slug = lw101SymbolSlug(symbolName);
    if (physicalSide === 1) {
      var eigen = (LW101_ICON_ADJ.back || {})[slug];
      if (eigen) return eigen;
      var vorne = (LW101_ICON_ADJ.front || {})[slug];
      return vorne ? lw101UebernimmAdj(vorne) : {};
    }
    return (LW101_ICON_ADJ.front || {})[slug] || {};
  }

  /* Beide Renderpfade fuer Motive muessen das anwenden, sonst ist es ein
     halber Regler: (1) das eigenstaendige Motiv im Modus "Symbol", (2) das
     inline-<img> in der Kombi-Marke "Symbol + Text". */
  function lw101IconStil(adj) {
    var teile = '';
    if (adj.dx || adj.dy) teile += 'translate:' + (adj.dx || 0) + 'em ' + (adj.dy || 0) + 'em;';
    if (adj.scale != null && adj.scale !== 1) teile += 'scale:' + adj.scale + ';';
    return teile;
  }

  function lw101Seite(physicalSide) {
    return physicalSide === 1 ? LW101_TUNE.back : LW101_TUNE.front;
  }

  var PREVIEW_TEXT = { top: 32.4, left: 49.5 };
  var PREVIEW_ICON = { top: 33, left: 45 };
  var PREVIEW_TEXT_BACK = { top: 66.8, left: 49.5 };
  var PREVIEW_ICON_BACK = mirrorPreviewPosBelow(PREVIEW_ICON);
  var PREVIEW_TEXT_SHORT_LEFT = 43.5;
  var PREVIEW_TEXT_SHORT_LEFT_BACK = 43.5;
  var PREVIEW_TEXT_SHORT_MAX_LEN = 2;

  function getTextLetterCount(text) {
    return String(text || '').trim().length;
  }

  function resolveTextPreviewLayout(text, basePos, physicalSide) {
    if (getTextLetterCount(text) <= PREVIEW_TEXT_SHORT_MAX_LEN) {
      var shortLeft = physicalSide === 1 ? PREVIEW_TEXT_SHORT_LEFT_BACK : PREVIEW_TEXT_SHORT_LEFT;
      return { top: basePos.top, left: shortLeft, align: 'short' };
    }
    return { top: basePos.top, left: basePos.left, align: 'center' };
  }

  function getActiveSideCount() {
    var domCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return domCount > 0 ? domCount : previewSideCount;
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function getColorKeyFromOption1() {
    var label = ($('[name="option1"]').attr('data-value') || '').toLowerCase();
    if (label.indexOf('ros') !== -1) return 'rosegold';
    if (label.indexOf('gold') !== -1 && label.indexOf('ros') === -1) return 'gold';
    return 'silver';
  }

  function ensureLw040GravurConfig() {
    if (window.lw101GravurConfig || typeof window.lwGravurResolveOption2 !== 'function') {
      return;
    }
    var config = window.lwGravurResolveOption2($('[name="option2"]').attr('data-value') || '');
    if (config) {
      window.lwGravurConfig = config;
      window.lw101GravurConfig = config;
    }
  }

  function usesFrontOnlyPreviewBase() {
    ensureLw040GravurConfig();
    var sides = window.lw101GravurConfig && window.lw101GravurConfig.physicalSides;
    return Array.isArray(sides) && sides.length === 1 && sides[0] === 0;
  }

  function getColorPreviewUrl() {
    var colorKey = getColorKeyFromOption1();
    if (usesFrontOnlyPreviewBase()) {
      return KE014_PREVIEW_IMAGES[colorKey + 'Vorder'] || KE014_PREVIEW_IMAGES[colorKey];
    }
    return KE014_PREVIEW_IMAGES[colorKey] || KE014_PREVIEW_IMAGES.silver;
  }

  function getSymbolByName(name) {
    if (!name) return null;
    var resolved = normalizeLw040StoredSymbol(name);
    var symbols = loadLw040Symbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved || symbols[i].text === name) return symbols[i];
    }
    return null;
  }

  function weightedLength(str, mode) {
    if (!str) return 0;
    var symbolCost = mode === 'symbol_text' ? SYMBOL_TEXT_COST : SYMBOL_COST;
    var total = 0;
    var re = /\(([^)]+)\)/g;
    var last = 0;
    var match;
    while ((match = re.exec(str)) !== null) {
      total += match.index - last;
      total += symbolCost;
      last = re.lastIndex;
    }
    total += str.length - last;
    return total;
  }

  function getSideMode(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    return $side.attr('data-lw040-mode') || sideModes[sideIndex] || 'zeichen';
  }

  function getSideIndexFromEl($el) {
    var $side = $el.closest('[class*="product_info_main_"]');
    if (!$side.length) return NaN;
    var match = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function getSideLabel(index) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
    var title = $.trim($side.find('.pattles-message-header span').first().text());
    return title || SIDE_LABELS[index] || ('Seite ' + (index + 1));
  }

  function ensurePreviewShell() {
    var $host = $('.up-Fenster-p-personalization-1 .fenster-content-contentin');
    if (!$host.length) return;

    if (!$host.find('.lw101-preview-wrap').length) {
      $host.prepend(
        '<div class="lw101-preview-wrap">' +
          '<div class="lw101-preview-label">Vorschau</div>' +
          '<div class="lw101-preview-stage" data-lw101-preview-stage>' +
            /* NIE loading="lazy" (GOTCHAS 27): das Fenster faehrt von ausserhalb des
               Viewports herein — dort laedt der Browser ein lazy-Bild nicht, und er
               prueft es beim Hereinfahren auch nicht neu. Das Basisbild bliebe grau,
               ohne Fehler in der Konsole (complete=false, naturalWidth 0). Real
               gemessen bei KS017, A203 und A227; Bestand am 2026-09-15 bereinigt. */
            '<img class="lw101-preview-base" alt="">' +
            '<div class="lw101-preview-layers"></div>' +
          '</div>' +
        '</div>'
      );
    }
  }

  function buildSymbolTextPreviewHtml(text, symbol, adjPhysicalSide) {
    var html = '';
    if (text) {
      html += esc(text);
    }
    if (symbol) {
      var sym = getSymbolByName(symbol);
      if (sym && sym.image) {
        // K2: das Motiv IN der Kombi-Marke einzeln bewegen. Ohne diesen
        // relativen Versatz liesse sich im Modus "Symbol + Text" nur die
        // ganze Marke schieben — Text und Motiv waeren aneinandergekettet.
        var mv = LW101_TUNE.kombiMotiv, mp = LW101_TUNE.motivPos;
        var mSt = 'position:relative;top:' + (mv.dy + mp.dy) + 'em;left:' + (mv.dx + mp.dx) + 'em;';
        // D1 fuer den ZWEITEN Renderpfad. Ohne diese Zeile wuerde der
        // Einzelregler nur im Modus "Symbol" wirken und in "Symbol + Text"
        // stillschweigend nichts tun — genau die halben Regler, vor denen
        // docs/TUNER-VOLLAUSBAU.md warnt.
        mSt += lw101IconStil(lw101IconAdj(adjPhysicalSide, symbol));
        html += '<img class="lw101-preview-symbol-text-icon" style="' + mSt + '" src="' +
          esc(sym.image) + '" alt="' + esc(symbol) + '">';
      }
    }
    return html;
  }

  function renderAllPreviewEngravings() {
    var $layers = $('[data-lw101-preview-stage] .lw101-preview-layers');
    $layers.empty();
    var zu = getActiveSideCount();

    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      if (!$side.length) continue;

      var parts = getSideEngraving(i);
      var text = $.trim(parts.text || '');
      var symbol = normalizeLw040StoredSymbol(parts.symbol || '');
      if (!text && !symbol) continue;

      var sideMode = getSideMode(i);
      var isSymbolTextMode = sideMode === 'symbol_text';
      var physicalSide = getPhysicalSideIndex(i);
      var baseTextPos = physicalSide === 1 ? PREVIEW_TEXT_BACK : PREVIEW_TEXT;
      var textLayout = resolveTextPreviewLayout(text, baseTextPos, physicalSide);
      var iconPos = physicalSide === 1 ? PREVIEW_ICON_BACK : PREVIEW_ICON;
      var textSideClass = physicalSide === 1 ? ' lw101-preview-text--back' : ' lw101-preview-text--front';
      var textAlignClass = textLayout.align === 'short' ? ' lw101-preview-text--short' : '';
      var iconSideClass = physicalSide === 1 ? ' lw101-preview-icon--back' : ' lw101-preview-icon--front';

      if (isSymbolTextMode) {
        var mixedHtml = buildSymbolTextPreviewHtml(text, symbol, physicalSide);
        if (!mixedHtml) continue;
        // Kombi-Marke: Text und Motiv sitzen in EINER Marke. Die Marke selbst
        // folgt der Block- und Kombi-Text-Verschiebung; das Motiv darin wird
        // weiter unten in buildSymbolTextPreviewHtml() separat versetzt.
        var mixedStyle = 'top:' + (textLayout.top + lw101Seite(physicalSide).text.dy + LW101_TUNE.kombiText.dy) +
          '%;left:' + (textLayout.left + lw101Seite(physicalSide).text.dx + LW101_TUNE.kombiText.dx) +
          '%;font-family:' + KE014_FONT.family + ';';
        $layers.append(
          '<div class="lw101-preview-text lw101-preview-text--symbol-text' + textSideClass + textAlignClass + '" style="' + mixedStyle + '">' +
            mixedHtml +
          '</div>'
        );
        continue;
      }

      if (text) {
        var textStyle = 'top:' + (textLayout.top + lw101Seite(physicalSide).text.dy) +
          '%;left:' + (textLayout.left + lw101Seite(physicalSide).text.dx +
            (textLayout.align === 'short' ? LW101_TUNE.kurzDx : 0)) +
          '%;font-family:' + KE014_FONT.family + ';';
        $layers.append('<div class="lw101-preview-text' + textSideClass + textAlignClass + '" style="' + textStyle + '">' + esc(text) + '</div>');
      }

      if (symbol) {
        var sym = getSymbolByName(symbol);
        if (sym && sym.image) {
          // Motiv als eigenes Element: Seiten-Versatz + Gesamt-Motivlage.
          var iconStyle = 'top:' + (iconPos.top + lw101Seite(physicalSide).motiv.dy + LW101_TUNE.motivPos.dy) +
            '%;left:' + (iconPos.left + lw101Seite(physicalSide).motiv.dx + LW101_TUNE.motivPos.dx) + '%;' +
            lw101IconStil(lw101IconAdj(physicalSide, symbol));
          $layers.append(
            '<div class="lw101-preview-icon' + iconSideClass + '" style="' + iconStyle + '">' +
              '<img src="' + esc(sym.image) + '" alt="' + esc(symbol) + '">' +
            '</div>'
          );
        }
      }
    }
  }

  // G4/G2: die Groessen stehen in CSS-Variablen (clamp). Statt sie zu
  // ersetzen, wird ein Faktor auf die Buehne geschrieben — 1 laesst die
  // Originalwerte exakt in Kraft, der Einbau ist damit neutral.
  function lw101GroessenAnwenden() {
    var st = document.querySelector('[data-lw101-preview-stage]');
    if (!st) return;
    st.style.setProperty('--lw101-block-scale', LW101_TUNE.blockScale);
    st.style.setProperty('--lw101-motiv-scale', LW101_TUNE.motivScale);
  }

  /* =====================================================================
     LW101 Tuner — ?lw101tuner=1
     Panel-Id endet auf -tuner und der Griff traegt .kt-title: damit haengen
     sich tuner-draggable (Ziehen, Positionsgedaechtnis) und tuner-sprache
     (DE/中) von selbst ein. Hier steht dafuer bewusst KEINE Zeile.
     ===================================================================== */
  /* ---- Reglerfenster: feste Vorlage (harte Regel 5). Bis 2026-08-15 war das
     Panel hier handgebaut — dieselben vier Blindgaenger-Klassen, die die
     Vorlage strukturell ausschliesst (Konfiguration in der Funktion, tote
     Refresh, CSS-Reihenfolge, Escaping). Migriert nach dem Muster der
     LW042/LW043-Familie; die alten Regler stehen unveraendert im statischen
     Teil, neu ist der Kontext-Teil mit D1. */
  function lw101TunerSichtbar() {
    var b = document.querySelector('[data-lw101-preview-stage]');
    if (!b) return false;
    var r = b.getBoundingClientRect();
    return r.width > 0 && r.height > 0
      && r.left < window.innerWidth && r.right > 0
      && r.top < window.innerHeight && r.bottom > 0;
  }

  function lw101IconRegler(seite, slug, feld, standard) {
    return { get: function () {
               /* Auf der Rueckseite zeigt der Regler den WIRKSAMEN Wert — also
                  den gespiegelten von vorne, solange die Rueckseite keinen
                  eigenen hat. Sonst staende dort 0, waehrend im Bild etwas
                  anderes passiert. Sobald jemand hier dreht, bekommt die
                  Rueckseite einen eigenen Eintrag und loest sich vom Spiegel. */
               var o = (LW101_ICON_ADJ[seite] || {})[slug];
               if (!o && seite === 'back') {
                 var vorne = (LW101_ICON_ADJ.front || {})[slug];
                 if (vorne) o = lw101UebernimmAdj(vorne);
               }
               return o && o[feld] != null ? o[feld] : standard;
             },
             set: function (v) {
               if (!LW101_ICON_ADJ[seite]) LW101_ICON_ADJ[seite] = {};
               if (!LW101_ICON_ADJ[seite][slug]) LW101_ICON_ADJ[seite][slug] = {};
               LW101_ICON_ADJ[seite][slug][feld] = v;
             } };
  }

  function lw101StatischeItems() {
    var T = LW101_TUNE;
    return [
      { h: 'Gesamt' },
      { label: 'Gesamt: Block-Größe ×', step: 0.02, get: function() { return T.blockScale; }, set: function(v) { T.blockScale = v; } },
      { label: 'Gesamt: Motiv-Größe ×', step: 0.02, get: function() { return T.motivScale; }, set: function(v) { T.motivScale = v; } },
      { label: 'Gesamt: Motive ↔ X %', step: 0.25, get: function() { return T.motivPos.dx; }, set: function(v) { T.motivPos.dx = v; } },
      { label: 'Gesamt: Motive ↕ Y %', step: 0.25, get: function() { return T.motivPos.dy; }, set: function(v) { T.motivPos.dy = v; } },
      { h: 'Vorderseite' },
      { label: 'Gesamt: Block ↔ X %', step: 0.25, get: function() { return T.front.text.dx; }, set: function(v) { T.front.text.dx = v; } },
      { label: 'Gesamt: Block ↕ Y %', step: 0.25, get: function() { return T.front.text.dy; }, set: function(v) { T.front.text.dy = v; } },
      { label: 'Motiv ↔ X % (Vorne)', step: 0.25, get: function() { return T.front.motiv.dx; }, set: function(v) { T.front.motiv.dx = v; } },
      { label: 'Motiv ↕ Y % (Vorne)', step: 0.25, get: function() { return T.front.motiv.dy; }, set: function(v) { T.front.motiv.dy = v; } },
      { h: 'Rückseite' },
      { label: 'Block ↔ X % (Hinten)', step: 0.25, get: function() { return T.back.text.dx; }, set: function(v) { T.back.text.dx = v; } },
      { label: 'Block ↕ Y % (Hinten)', step: 0.25, get: function() { return T.back.text.dy; }, set: function(v) { T.back.text.dy = v; } },
      { label: 'Motiv ↔ X % (Hinten)', step: 0.25, get: function() { return T.back.motiv.dx; }, set: function(v) { T.back.motiv.dx = v; } },
      { label: 'Motiv ↕ Y % (Hinten)', step: 0.25, get: function() { return T.back.motiv.dy; }, set: function(v) { T.back.motiv.dy = v; } },
      { h: 'Symbol + Text (Kombi)' },
      { label: 'Kombi: Text ↔ X %', step: 0.25, get: function() { return T.kombiText.dx; }, set: function(v) { T.kombiText.dx = v; } },
      { label: 'Kombi: Text ↕ Y %', step: 0.25, get: function() { return T.kombiText.dy; }, set: function(v) { T.kombiText.dy = v; } },
      { label: 'Kombi: Motiv ↔ X %', step: 0.05, get: function() { return T.kombiMotiv.dx; }, set: function(v) { T.kombiMotiv.dx = v; } },
      { label: 'Kombi: Motiv ↕ Y %', step: 0.05, get: function() { return T.kombiMotiv.dy; }, set: function(v) { T.kombiMotiv.dy = v; } },
      { h: 'Kurzer Text (≤ 2 Zeichen)' },
      { label: 'Kurztext ↔ X %', step: 0.25, get: function() { return T.kurzDx; }, set: function(v) { T.kurzDx = v; } }
    ];
  }

  /* D1 — je Motiv und je physischer Seite. Angezeigt wird nur, was gerade
     wirklich graviert ist; sonst stuenden 11 Motive x 2 Seiten im Panel. */
  function lw101KontextItems() {
    if (!lw101TunerSichtbar()) {
      return [{ h: '\u201EJetzt personalisieren\u201C \u00F6ffnen \u2014 die Vorschau ist zugeklappt' }];
    }
    var items = [];
    var n = getActiveSideCount();
    for (var i = 0; i < n; i++) {
      /* Physische Seite, nicht UI-Index: bei "Nur Rueckseite"-Varianten ist die
         einzige UI-Seite (Index 0) physisch die Rueckseite. */
      var seite = getPhysicalSideIndex(i) === 1 ? 'back' : 'front';
      var symName = getSideEngraving(i).symbol;
      if (!symName) continue;
      var slug = lw101SymbolSlug(symName);
      var ix = lw101IconRegler(seite, slug, 'dx', 0),
          iy = lw101IconRegler(seite, slug, 'dy', 0),
          ig = lw101IconRegler(seite, slug, 'scale', 1);
      var eigenerWert = !!(LW101_ICON_ADJ[seite] || {})[slug];
      items.push({ h: (seite === 'back' ? 'R\u00FCckseite' : 'Vorderseite') + ' \u00B7 Motiv \u00B7 ' + symName
        + (seite === 'back' && !eigenerWert ? '  (von vorne uebernommen)' : '') });
      items.push({ label: 'Motiv ↔ X %', step: 0.02, get: ix.get, set: ix.set });
      items.push({ label: 'Motiv ↕ Y %', step: 0.02, get: iy.get, set: iy.set });
      items.push({ label: 'Motiv-Größe', step: 0.05, get: ig.get, set: ig.set });
    }
    if (!items.length) items.push({ h: 'Kein Motiv gew\u00E4hlt' });
    return items;
  }

  function lw101KontextKey() {
    var teile = [lw101TunerSichtbar() ? 'offen' : 'zu'];
    var n = getActiveSideCount();
    for (var i = 0; i < n; i++) {
      teile.push(getPhysicalSideIndex(i));
      teile.push(getSideEngraving(i).symbol || '');
    }
    return teile.join('|');
  }

  (window.VivTuner = window.VivTuner || { q: [], refresh: function () {}, register: function () {
    this.q.push(arguments); return { refresh: function () {} };
  } }).register('lw101', {
    titel: 'LW101 Tuner',
    statisch: lw101StatischeItems,
    kontext: lw101KontextItems,
    kontextKey: lw101KontextKey,
    update: function () { window.lw101UpdatePreview(); },
    exportiere: function () {
      return { TUNE: LW101_TUNE, ICON_ADJ: LW101_ICON_ADJ };
    }
  });

  window.lw101UpdatePreview = function() {
    /* Ohne diesen Refresh bleibt der Kontext-Teil des Panels beim ersten
       Zustand stehen (A184-Lektion). */
    if (window.VivTuner) VivTuner.refresh('lw101');
    ensurePreviewShell();
    lw101GroessenAnwenden();
    var baseUrl = getColorPreviewUrl();
    var $stage = $('[data-lw101-preview-stage]');
    $stage.find('.lw101-preview-base').attr('src', baseUrl);
    renderAllPreviewEngravings();
  };

  function parseEngravingValue(raw) {
    var val = raw || '';
    var match = val.match(/\(([^)]+)\)$/);
    if (match && getSymbolByName(match[1])) {
      return {
        text: val.substring(0, val.length - match[0].length),
        symbol: normalizeLw040StoredSymbol(match[1])
      };
    }
    return { text: val, symbol: '' };
  }

  function composeEngraving(text, symbol) {
    return (text || '') + (symbol ? '(' + symbol + ')' : '');
  }

  function getSideEngraving(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    var mode = getSideMode(sideIndex);
    var symbol = normalizeLw040StoredSymbol($side.attr('data-lw040-symbol') || '');

    if (mode === 'symbol') {
      return { text: '', symbol: symbol };
    }

    if (mode === 'symbol_text') {
      return { text: $.trim($input.val() || ''), symbol: symbol };
    }

    return { text: $.trim($input.val() || ''), symbol: '' };
  }

  function getComposedEngraving(sideIndex) {
    var parts = getSideEngraving(sideIndex);
    return composeEngraving(parts.text, parts.symbol);
  }

  function captureSideEngraving(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    var mode = getSideMode(sideIndex);
    var symbol = normalizeLw040StoredSymbol($side.attr('data-lw040-symbol') || '');
    var text;

    if (mode === 'symbol') {
      return { text: '', symbol: symbol };
    }

    if (mode === 'symbol_text') {
      text = $.trim($input.val() || '');
      return { text: text, symbol: symbol };
    }

    var parsed = parseEngravingValue($input.val() || '');
    text = $.trim(parsed.text || $input.val() || '');
    symbol = normalizeLw040StoredSymbol(symbol || parsed.symbol);
    return { text: text, symbol: mode === 'zeichen' ? '' : symbol };
  }

  function syncSymbolGridSelection(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var selected = getSideEngraving(sideIndex).symbol;
    var $grid = $side.find('.lw040-symbol-grid');
    $grid.find('button').removeClass('is-active');
    if (selected) {
      $grid.find('button[data-symbol="' + selected + '"]').addClass('is-active');
    }
  }

  function ensureSymbolGrid(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var symbols = loadLw040Symbols();
    var $grid = $side.find('.lw040-symbol-grid');
    if (!$grid.length || $grid.find('button').length !== symbols.length) {
      $grid.remove();
      $side.find('.p-w-plattchen-list-number-header').after(buildSymbolGrid(sideIndex));
    } else {
      syncSymbolGridSelection(sideIndex);
    }
    $side.find('.lw040-symbol-grid').show();
  }

  function setSymbolSelection(sideIndex, symName) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    if (!$input.length || !symName) return;
    symName = normalizeLw040StoredSymbol(symName);
    var mode = getSideMode(sideIndex);

    var current = normalizeLw040StoredSymbol($side.attr('data-lw040-symbol') || '');
    if (current === symName) {
      symName = '';
    }

    if (mode === 'symbol_text') {
      var parts = captureSideEngraving(sideIndex);
      var composed = composeEngraving(parts.text, symName);
      if (weightedLength(composed, 'symbol_text') > CHAR_MAX) return;
      $side.attr('data-lw040-symbol', symName);
      updateCharCounter($input, sideIndex);
      syncSymbolGridSelection(sideIndex);
      window.lw101UpdatePreview();
      return;
    }

    $side.attr('data-lw040-symbol', symName);
    $side.attr('data-lw040-mode', 'symbol');
    sideModes[sideIndex] = 'symbol';
    $input.val('');

    updateCharCounter($input, sideIndex);
    syncSymbolGridSelection(sideIndex);
    window.lw101UpdatePreview();
  }

  function buildSymbolGrid(sideIndex) {
    var symbols = loadLw040Symbols();
    var selected = getSideEngraving(sideIndex).symbol;
    var html = '<div class="lw040-symbol-grid" data-side="' + sideIndex + '">';
    for (var i = 0; i < symbols.length; i++) {
      var sym = symbols[i];
      var activeAttr = sym.text === selected ? ' class="is-active"' : '';
      html += '<button type="button"' + activeAttr + ' data-symbol="' + esc(sym.text) + '" title="' + esc(sym.text) + '">' +
        '<img src="' + esc(sym.image) + '" alt="' + esc(sym.text) + '" loading="lazy">' +
        '<span class="lw040-symbol-label">' + esc(sym.text) + '</span>' +
      '</button>';
    }
    html += '</div>';
    return html;
  }

  function applyFixedFont($input) {
    $input.css('font-family', KE014_FONT.family);
    $input.attr('data-font-family', KE014_FONT.name);
  }

  function updateCharCounter($input, sideIndex) {
    if (isNaN(sideIndex)) {
      sideIndex = getSideIndexFromEl($input);
    }
    var mode = isNaN(sideIndex) ? 'zeichen' : getSideMode(sideIndex);
    var composed = isNaN(sideIndex) ? ($input.val() || '') : getComposedEngraving(sideIndex);
    var len = weightedLength(composed, mode);
    var $words = $input.siblings('.number-header-words');
    $words.find('.number-1').text(len);
    $words.find('.wordsNum_v1').text(CHAR_MAX);
    if (composed) {
      $input.siblings('.number-header-icon').css('display', 'block');
    } else {
      $input.siblings('.number-header-icon').css('display', 'none');
    }
  }

  function setSideMode(sideIndex, mode) {
    sideModes[sideIndex] = mode;
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var parts = captureSideEngraving(sideIndex);
    $side.attr('data-lw040-mode', mode);
    $side.find('.lw040-mode-switch button').removeClass('is-active');
    $side.find('.lw040-mode-switch button[data-mode="' + mode + '"]').addClass('is-active');

    var $textareaBlock = $side.find('.p-w-plattchen-list-number-header');
    var $tabParameter = $side.find('.pattles-tab-parameter');
    var $input = $side.find('.text_class_' + sideIndex);

    $side.find('.lw040-side-error').hide();
    $side.removeClass('has-error');

    if (mode === 'zeichen') {
      $tabParameter.show();
      $textareaBlock.show();
      $side.find('.font_main').hide();
      $side.find('.image_main').hide();
      $side.find('.lw040-symbol-grid').hide();
      $side.attr('data-type', 'text');
      $side.attr('data-lw040-symbol', '');
      $input.val(parts.text || '');
      $input.prop('readonly', false);
      applyFixedFont($input);
    } else if (mode === 'symbol') {
      $tabParameter.show();
      $textareaBlock.hide();
      $side.find('.font_main').hide();
      $side.find('.image_main').hide();
      ensureSymbolGrid(sideIndex);
      $side.attr('data-type', 'image');
      $side.attr('data-lw040-symbol', parts.symbol || '');
      $input.val('');
      applyFixedFont($input);
      syncSymbolGridSelection(sideIndex);
    } else if (mode === 'symbol_text') {
      $tabParameter.show();
      $textareaBlock.show();
      $side.find('.font_main').hide();
      $side.find('.image_main').hide();
      ensureSymbolGrid(sideIndex);
      $side.attr('data-type', 'text');
      $side.attr('data-lw040-symbol', parts.symbol || '');
      $input.val(parts.text || '');
      $input.prop('readonly', false);
      applyFixedFont($input);
      syncSymbolGridSelection(sideIndex);
    }

    updateCharCounter($input, sideIndex);
    window.lw101UpdatePreview();
  }

  function bindSideEvents() {
    var $popup = $('.up-Fenster-p-personalization-1');

    $popup.find('.lw040-mode-switch button').off('click.lw040').on('click.lw040', function() {
      var idx = getSideIndexFromEl($(this));
      if (isNaN(idx)) return;
      setSideMode(idx, $(this).data('mode'));
    });

    /* [3] Kopfzeile klappt ihre Seite auf; die andere geht dabei zu. */
    $popup.off('click.lw101Side', '.lw101-side--klappbar > .pattles-message-header')
      .on('click.lw101Side', '.lw101-side--klappbar > .pattles-message-header', function() {
        var $side = $(this).parent();
        if ($side.hasClass('is-side-open')) return;
        var treffer = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
        if (!treffer) return;
        lw101OpenSide(parseInt(treffer[1], 10), true);
      });

    $popup.off('click.lw101Symbol', '.lw040-symbol-grid button').on('click.lw101Symbol', '.lw040-symbol-grid button', function() {
      var idx = getSideIndexFromEl($(this));
      if (isNaN(idx)) return;
      var symName = $(this).attr('data-symbol');
      if (!symName) return;
      setSymbolSelection(idx, symName);
    });

    $popup.find('.number-header-textarea').off('input.lw040 propertychange.lw040').on('input.lw040 propertychange.lw040', function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      if (isNaN(idx)) return;
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + idx);
      var mode = $side.attr('data-lw040-mode') || 'zeichen';

      if (mode === 'zeichen') {
        var text = $input.val() || '';
        $side.attr('data-lw040-symbol', '');
        while (weightedLength(text, mode) > CHAR_MAX && text.length) {
          text = text.slice(0, -1);
        }
        $input.val(text);
      } else if (mode === 'symbol_text') {
        var mixedText = $input.val() || '';
        var mixedSymbol = normalizeLw040StoredSymbol($side.attr('data-lw040-symbol') || '');
        while (weightedLength(composeEngraving(mixedText, mixedSymbol), mode) > CHAR_MAX && mixedText.length) {
          mixedText = mixedText.slice(0, -1);
        }
        $input.val(mixedText);
      } else {
        return;
      }

      updateCharCounter($input, idx);
      window.lw101UpdatePreview();
    });

    $popup.find('.number-header-icon').off('click.lw040').on('click.lw040', function() {
      var $input = $(this).siblings('.number-header-textarea');
      var idx = getSideIndexFromEl($input);
      if (isNaN(idx)) return;
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + idx);
      var mode = getSideMode(idx);
      if (mode === 'symbol_text') {
        $side.attr('data-lw040-symbol', '');
      }
      $input.val('');
      updateCharCounter($input, idx);
      syncSymbolGridSelection(idx);
      $(this).css('display', 'none');
      window.lw101UpdatePreview();
    });
  }

  /* Liegendes Kreuz mit zwei Oesen — der echte Anhaenger dieser Vorlage.
     Zeichenweise wie LW042: senkrechter Balken mit Kontur, danach der
     Querbalken (seine weisse Fuellung deckt die Linien darin ab), zuletzt eine
     strichlose Fuellung ueber dem senkrechten Balken. Uebrig bleibt die
     Aussenkontur. Die Oesen kommen zuletzt obenauf. */
  var LW101_KREUZ_SVG =
    '<svg class="lw101-layout-kreuz" viewBox="0 0 100 100" aria-hidden="true">' +
      '<rect class="lw101-kreuz-linie" x="38" y="24" width="16" height="52" rx="8"/>' +
      '<rect class="lw101-kreuz-linie" x="9" y="42" width="82" height="16" rx="8"/>' +
      '<rect class="lw101-kreuz-fuellung" x="39.2" y="25.2" width="13.6" height="49.6" rx="6.8"/>' +
      '<circle class="lw101-kreuz-oese" cx="17" cy="50" r="3.6"/>' +
      '<circle class="lw101-kreuz-oese" cx="83" cy="50" r="3.6"/>' +
    '</svg>';

  function lw101BuildModeSwitch() {
    var herzSym = getSymbolByName('Herz');
    var herzImg = herzSym && herzSym.image
      ? '<img src="' + esc(herzSym.image) + '" alt="Herz">'
      : '&#9825;';

    function karte(mode, ovlClass, ovlHtml, name, sub) {
      return '<button type="button" data-mode="' + mode + '">' +
        '<span class="lw101-layout-icon">' +
          LW101_KREUZ_SVG +
          '<span class="lw101-layout-ovl' + ovlClass + '">' + ovlHtml + '</span>' +
        '</span>' +
        '<span class="lw101-layout-name">' + name + '</span>' +
        '<span class="lw101-layout-sub">' + sub + '</span>' +
      '</button>';
    }

    /* Die data-mode-Werte bleiben exakt die alten (zeichen / symbol /
       symbol_text) — setSideMode, Speicherstand und Bestellausgabe haengen
       daran. Getauscht wird nur das Aussehen. */
    return '<div class="lw040-mode-switch">' +
        karte('zeichen', '', 'Anna', 'Nur Text', 'z.B. ein Name') +
        karte('symbol', ' lw101-layout-ovl--gross', herzImg, 'Nur Motiv', 'nur ein Symbol') +
        karte('symbol_text', '', 'Anna' + herzImg, 'Text mit Motiv', 'Text + Symbol') +
      '</div>' +
      '<p class="lw040-side-error">Bitte gib einen Gravurtext ein, wähle ein Symbol, ' +
      'oder beides im Modus Text mit Motiv.</p>';
  }

  function setupSide(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (!$side.length) return;

    $side.find('.pattles-tab-header').hide();

    /* Gravurstil-Karten (K530-Form): der Anhaenger als Strichbild, darauf die
       Beispielgravur an derselben waagerechten Position wie in der echten
       Vorschau. Die alten drei Textreiter werden ersetzt — erkennbar daran,
       dass die Karten-Auszeichnung fehlt. */
    if (!$side.find('.lw040-mode-switch .lw101-layout-icon').length) {
      $side.find('.lw040-mode-switch, .lw040-side-error').remove();
      $side.find('.pattles-message-header').after(lw101BuildModeSwitch());
    }

    var $input = $side.find('.text_class_' + sideIndex);
    if (typeof $side.attr('data-lw040-symbol') === 'undefined') {
      var initial = parseEngravingValue($input.val() || '');
      if (initial.symbol && $.trim(initial.text)) {
        sideModes[sideIndex] = 'symbol_text';
        $side.attr('data-lw040-symbol', normalizeLw040StoredSymbol(initial.symbol));
        $input.val($.trim(initial.text));
      } else if (initial.symbol && !$.trim(initial.text)) {
        sideModes[sideIndex] = 'symbol';
        $side.attr('data-lw040-symbol', normalizeLw040StoredSymbol(initial.symbol));
        $input.val('');
      } else {
        sideModes[sideIndex] = 'zeichen';
        $side.attr('data-lw040-symbol', '');
        $input.val($.trim(initial.text || $input.val() || ''));
      }
    }
    applyFixedFont($input);
    $input.attr('placeholder', 'Gib deinen Gravurtext ein.');
    $input.attr('maxlength', 40);

    var $words = $side.find('.number-header-words');
    if ($words.length) {
      $words.html('<span class="number-1">0</span> / <span class="wordsNum_v1">' + CHAR_MAX + '</span>');
    }

    setSideMode(sideIndex, sideModes[sideIndex] || 'zeichen');
  }

  /* ==================================================================
     FOKUS — K530-Anzeigestandard (Yin 2026-08-15). Nur Darstellung und
     Bedienung; die Bestell-Eigenschaften bleiben Zeichen fuer Zeichen
     unveraendert.
     ================================================================== */

  function lw101SideEl(index) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
  }

  function lw101AlleSeiten() {
    return $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
  }

  function lw101ScrollEl() {
    return $('.up-Fenster-p-personalization-1')
      .find('.fenster-content-inner, .fenster-content-contentin').get(0);
  }

  /* ⚠️ Der Scroll-Container traegt ein padding-top — sticky pinnt an der
     INNENkante, nicht an der Rahmenkante. Ohne dieses Polster im Vergleich
     gilt die Vorschau nie als angepinnt und weicht nie aus (LW042-Lektion). */
  function lw101ScrollPolster(scrollEl) {
    return parseFloat((window.getComputedStyle(scrollEl) || {}).paddingTop) || 0;
  }

  function lw101ScrollSideIntoView($side) {
    var scrollEl = lw101ScrollEl();
    if (!scrollEl || !$side || !$side.length) return;
    var versatz = 8;
    var $pv = $('.lw101-preview-wrap').first();
    if ($pv.length && $pv.css('position') === 'sticky') {
      versatz += ($pv.outerHeight() || 0) + lw101ScrollPolster(scrollEl);
    }
    var top = $side[0].getBoundingClientRect().top
      - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - versatz;
    scrollEl.scrollTop = Math.max(0, top);
  }

  /* [3] Seiten-Akkordeon: nur bei beidseitiger Gravur, dann ist immer genau
     eine Seite offen. Der Zustand ueberlebt den Neuaufbau des Popups. */
  var lw101OffeneSeite = 0;

  function lw101EnsureChevron($side) {
    var $head = $side.children('.pattles-message-header');
    /* Der Titel-<span> bleibt das ERSTE Kind — getSideLabel liest ihn per
       .first(), das Chevron haengt dahinter. */
    if ($head.length && !$head.children('.lw101-side-chev').length) {
      $head.append('<span class="lw101-side-chev" aria-hidden="true">▾</span>');
    }
  }

  function lw101OpenSide(index, scrollen) {
    var $sides = lw101AlleSeiten();
    if (!$sides.filter('.lw101-side--klappbar').length) return;
    lw101OffeneSeite = index;
    $sides.removeClass('is-side-open');
    var $ziel = lw101SideEl(index).addClass('is-side-open');
    if (scrollen) lw101ScrollSideIntoView($ziel);
  }

  function lw101ApplyAkkordeon(zu) {
    var $sides = lw101AlleSeiten();
    if (zu < 2) {
      /* Einseitig: kein Akkordeon — die Klasse wegnehmen, damit die
         Zuklapp-Regeln nichts verstecken koennen. */
      $sides.removeClass('lw101-side--klappbar').addClass('is-side-open');
      return;
    }
    $sides.addClass('lw101-side--klappbar').each(function() {
      lw101EnsureChevron($(this));
    });
    var ziel = (lw101OffeneSeite >= 0 && lw101OffeneSeite < zu) ? lw101OffeneSeite : 0;
    $sides.removeClass('is-side-open');
    lw101SideEl(ziel).addClass('is-side-open');
    lw101OffeneSeite = ziel;
  }

  window.lw101ValidateBeforeOpen = function() { return true; };

  window.lw101AfterUpdateSize = function(zu) {
    if (window.lw101GravurConfig && window.lw101GravurConfig.physicalSides) {
      setPhysicalSideMap(window.lw101GravurConfig.physicalSides);
    } else {
      var parsedZu = parseInt(zu, 10) || 0;
      var defaultMap = [];
      for (var mapIndex = 0; mapIndex < parsedZu; mapIndex++) defaultMap.push(mapIndex);
      setPhysicalSideMap(defaultMap);
    }

    zu = parseInt(zu, 10) || 0;
    if (zu < 1) {
      return;
    }
    zu = Math.min(zu, 2);
    previewSideCount = zu;
    ensurePreviewShell();
    for (var i = 0; i < zu; i++) {
      setupSide(i);
    }
    lw101ApplyAkkordeon(zu);
    bindSideEvents();
    window.lw101UpdatePreview();
  };

  window.lw101OnPopupOpen = function() {
    lw040SymbolsCache = null;
    if (window.lw101RefreshPopupSides) {
      lw101RefreshPopupSides();
    }
    ensurePreviewShell();
    var $sides = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
    previewSideCount = $sides.length || previewSideCount;
    if (window.lw101AfterUpdateSize) {
      lw101AfterUpdateSize(previewSideCount);
    } else {
      bindSideEvents();
      window.lw101UpdatePreview();
    }
  };

  window.lw101OnPopupClose = function() {
    $('.product-info--lw101 [class*="product_info_main_"]').removeClass('has-error');
  };

  window.lw101ValidateSides = function(zu) {
    zu = Math.min(Math.max(parseInt(zu, 10) || 1, 1), 2);
    var valid = true;
    var ersteFehlerSeite = -1;
    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      var mode = getSideMode(i);
      $side.removeClass('has-error');
      $side.find('.lw040-side-error').hide();
      $side.find('.text_class_' + i).parent().removeClass('error');

      var engraving = getSideEngraving(i);
      var sideValid = false;
      if (mode === 'symbol_text') {
        sideValid = !!$.trim(engraving.text) && !!engraving.symbol;
      } else {
        sideValid = !!$.trim(getComposedEngraving(i));
      }

      if (!sideValid) {
        valid = false;
        $side.addClass('has-error');
        $side.find('.text_class_' + i).parent().addClass('error');
        $side.find('.lw040-side-error').show();
        if (ersteFehlerSeite < 0) ersteFehlerSeite = i;
      }
    }
    if (!valid) {
      /* [6] Fokus-Regel: nur die ERSTE fehlerhafte Seite aufklappen und
         anspringen. Weitere fehlerhafte Seiten tragen am zugeklappten Kopf
         ein rotes „!" und kommen beim naechsten Klick der Reihe nach dran. */
      if (ersteFehlerSeite >= 0) lw101OpenSide(ersteFehlerSeite, false);
      alert('Bitte fülle die Gravur für jede Seite aus.');
      if (ersteFehlerSeite >= 0) lw101ScrollSideIntoView(lw101SideEl(ersteFehlerSeite));
    }
    return valid;
  };

  window.lw101AppendSideProperties = function(properies_arr, zu, popup_title) {
    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }

      var engraving = getSideEngraving(i);
      var composed = composeEngraving(engraving.text, engraving.symbol);
      if (!$.trim(composed)) continue;

      /* Bei Text+Motiv bleibt es bei ZWEI Zeilen wie bisher: die gemischte
         Zeile (so wie graviert wird) und das Motiv nochmal einzeln — die
         Werkstatt ist das so gewohnt, und der Parser hat damit sogar zwei
         Treffer statt einem. */
      var orderRow = symbolOrderRow(title, engraving, true);
      if ($.trim(orderRow.value)) properies_arr.push([orderRow.name, orderRow.value]);
      if (engraving.text) properies_arr.push([title + ' Font', KE014_FONT.name]);
      if (engraving.text && engraving.symbol) {
        properies_arr.push([title + ' Motiv', formatSymbolOrderValue(engraving.symbol)]);
      }
    }
  };

  window.lw101ConfirmHtml = function(zu, popup_title) {
    var html = '';
    var template = $('#form_message_option2').html() || $('#form_message_option').html();
    if (!template) return '';

    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }

      var engraving = getSideEngraving(i);
      var composed = composeEngraving(engraving.text, engraving.symbol);
      if (!$.trim(composed)) continue;

      var confirmRow = symbolOrderRow(title, engraving, false);
      if ($.trim(confirmRow.value)) {
        html += template.replaceAll('{option_name}', confirmRow.name).replaceAll('{option_value}', confirmRow.value);
      }
      if (engraving.text) {
        html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', KE014_FONT.name);
      }
      if (engraving.text && engraving.symbol) {
        html += template.replaceAll('{option_name}', title + ' Motiv').replaceAll('{option_value}', normalizeLw040StoredSymbol(engraving.symbol));
      }
    }
    if (html) {
      /* [7] Platzhalter fuer den Vorschau-Streifen — befuellt wird er per
         DOM-Klon NACH dem Einhaengen der Bestaetigungsseite. */
      html = '<div class="lw101-confirm-vorschau" aria-hidden="true"></div>' + html;
    }
    return html;
  };

  /* [7] Vorschau-Streifen auf der Bestaetigungsseite: klont die live gerenderte
     Buehne aus dem Popup — gleiche Seite, gleiche Styles und Schrift, also
     pixelgleich zum Popup. LW101 hat GENAU EINE Buehne (bei beidseitiger
     Gravur zeigt das Basisbild beide Kreuze uebereinander), also eine Kachel.
     WICHTIG: beim Bestaetigen ist das Popup zu, die Buehne also 0 breit —
     darum vorher unsichtbar messbar machen (fixed, -9999px), frisch rendern,
     klonen, alles zurueckdrehen. */
  function lw101FillConfirmVorschau() {
    var $ziel = $('.message-confirm-item-2 .lw101-confirm-vorschau').last();
    if (!$ziel.length || $ziel.children().length) return;
    var $popup = $('.up-Fenster-p-personalization-1');
    if (!$popup.length) return;

    var altStyle = $popup.attr('style') || '';
    $popup.css({ display: 'block', visibility: 'hidden', position: 'fixed', left: '-9999px', top: '0' });
    window.lw101UpdatePreview();

    var $stage = $('[data-lw101-preview-stage]').first();
    var sw = $stage.length ? $stage[0].offsetWidth : 0;
    var sh = $stage.length ? $stage[0].offsetHeight : 0;
    if (sw && sh) {
      var ZIEL_B = Math.max(64, Math.min(130, $ziel.width() || 320));
      var f = ZIEL_B / sw;
      var $clip = $('<div class="lw101-cv-clip"></div>')
        .css({ width: ZIEL_B + 'px', height: Math.ceil(sh * f) + 'px', overflow: 'hidden' });
      var $scale = $('<div class="lw101-cv-scale"></div>')
        .css({ width: sw + 'px', transform: 'scale(' + f + ')', 'transform-origin': 'top left' });
      $scale.append($stage.clone());
      $clip.append($scale);
      var name = previewSideCount > 1
        ? 'VS · RS'
        : (physicalSideMap[0] === 1 ? 'RS' : 'VS');
      $ziel.append($('<div class="lw101-cv-item"></div>')
        .css('width', ZIEL_B + 'px')
        .append($clip)
        .append('<div class="lw101-cv-name">' + esc(name) + '</div>'));
    }

    $popup.attr('style', altStyle);
  }

  window.lw101EnhanceConfirmOptions = function() {
    /* laeuft im Event-File VOR dem Einhaengen von .message-confirm-item-2 —
       der Handler dort ist synchron, also reicht ein Tick Verzoegerung. */
    setTimeout(lw101FillConfirmVorschau, 0);
  };


  $(document).on('change.lw101Color', '[name="option1"]', function() {
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) {
      window.lw101UpdatePreview();
    }
  });

  $(document).on('change.lw101GravurOption', '[name="option2"]', function() {
    window.lw101GravurConfig = null;
    window.lwGravurConfig = null;
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) {
      window.lw101UpdatePreview();
    }
  });

})(jQuery);
